import React from "react";
import {AC_DEV_LEVEL, PAYMENT_TYPE, SUBSCRIPTION_ROOT_PAGES, VDS_LEVEL, VRI_LEVEL} from "../../../constants";
import PlanHeaderNotes from "../../common/subscriptions/PlanHeaderNotes";

const getVRISubtitle = (hasNoneVRI, isActiveDemoResellerAccount, isExpiredDemoResellerAccount) => {
    if (hasNoneVRI)
        return i18n.payments.vri.productNote;
    else if (isActiveDemoResellerAccount)
        return i18n.payments.vri.activeDemoResellerNote;
    else if (isExpiredDemoResellerAccount)
        return i18n.payments.vri.expiredDemoResellerNote;

    return null;
}

const getVDSSubtitle = (hasNoneVDS, isActiveDemoResellerAccount, isExpiredDemoResellerAccount) => {
    if (hasNoneVDS)
        return i18n.payments.vds.productNote;
    else if (isActiveDemoResellerAccount)
        return i18n.payments.vds.activeDemoResellerNote;
    else if (isExpiredDemoResellerAccount)
        return i18n.payments.vds.expiredDemoResellerNote;

    return null;
}

const HomeContainer = ({ rootPage, settings, appCenterData, vriData, vdsData, setRootPage }) => {

    const isBasic = appCenterData?.devLevel === AC_DEV_LEVEL.BASIC;
    const hasNoneVRI = vriData?.level === VRI_LEVEL.NONE;
    const hasNoneVDS = vdsData?.level === VDS_LEVEL.NONE;

    if (!settings || !appCenterData || rootPage !== SUBSCRIPTION_ROOT_PAGES.HOME)
        return <></>;

    const { isActiveDemoResellerAccount, isExpiredDemoResellerAccount } = appCenterData;
    const isDemoResellerAccount = isActiveDemoResellerAccount || isExpiredDemoResellerAccount;

    const vriSubtitle = getVRISubtitle(hasNoneVRI, isActiveDemoResellerAccount, isExpiredDemoResellerAccount);
    const vdsSubtitle = getVDSSubtitle(hasNoneVDS, isActiveDemoResellerAccount, isExpiredDemoResellerAccount);

    return (
        <div className={`plan-container flexColumn`}
             data-testid={'homeContainer'}>
            {
                isBasic && hasNoneVRI && hasNoneVDS && (
                    <div style={{ marginBottom: '0.75em', fontWeight: 'bold', fontSize: '1.5em' }}
                         data-testid={'newSubscriptionUserNote'}>
                        {i18n.payments.newSubscriptionUserNote}
                    </div>
                )
            }

            {
                !isBasic && (
                    <PlanHeaderNotes title={i18n.payments.ac.title}
                                     paymentType={PAYMENT_TYPE.AC}
                                     testid={'acHomeHeaderNotesDiv'}
                                     onPaymentTypeClick={() => setRootPage(SUBSCRIPTION_ROOT_PAGES.AC)}
                                     data={appCenterData}/>
                )
            }

            <PlanHeaderNotes title={i18n.payments.vri.title}
                             subtitle={vriSubtitle}
                             paymentType={PAYMENT_TYPE.VRI}
                             testid={'vriHomeHeaderNotesDiv'}
                             disabled={isDemoResellerAccount}
                             onPaymentTypeClick={() => setRootPage(SUBSCRIPTION_ROOT_PAGES.VRI)}
                             isDemoResellerAccount={isDemoResellerAccount}
                             data={vriData}/>

            <PlanHeaderNotes title={i18n.payments.vds.title}
                             subtitle={vdsSubtitle}
                             paymentType={PAYMENT_TYPE.VDS}
                             testid={'vdsHomeHeaderNotesDiv'}
                             disabled={isDemoResellerAccount}
                             onPaymentTypeClick={() => setRootPage(SUBSCRIPTION_ROOT_PAGES.VDS)}
                             isDemoResellerAccount={isDemoResellerAccount}
                             data={vdsData}/>
        </div>
    );
};

export default HomeContainer;